import { PropsWithChildren, useLayoutEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import uuid4 from 'uuid4';

import { createWrapperAndAppendToBody } from './createWrapperAndAppendToBody';

interface PortalProps {
  wrapperId?: string;
}

const Portal = ({ children, wrapperId }: PropsWithChildren<PortalProps>) => {
  const [wrapperForPortal, setWrapperForPortal] = useState<Element>();
  const id = useMemo(() => wrapperId || uuid4(), [wrapperId]);

  useLayoutEffect(() => {
    const existing = document.getElementById(id);
    const element = existing ?? createWrapperAndAppendToBody(id);
    const didCreate = !existing;

    setWrapperForPortal(element);

    return () => {
      if (didCreate) element.remove();
    };
  }, [id]);

  if (!wrapperForPortal) return null;

  return createPortal(children, wrapperForPortal);
};

export default Portal;
